<template>
    <div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">SEKTORI</h3>
                        <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                            @click="sector = {}; editSector = true">Novi sektor</base-button>
                    </template>


                    <el-table :data="sectors" v-loading="zonesLoading">
                        <el-table-column min-width="150" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column min-width="100" prop="numberOfParkings" label="Broj lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.numberOfParkings }}</span>
                            </template>
                        </el-table-column> -->


                        <el-table-column min-width="400" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" size="sm"
                                        @click="sector = scope.row; editSector = true" class="btn-link">
                                        Izmeni
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Lokacije" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" size="sm" class="btn-link"
                                        @click="sector = scope.row; getSectorParkings()">
                                        Parking lokacije
                                    </base-button>
                                </el-tooltip>

                                <!-- <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="zone = scope.row; deletePrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip> -->
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>

            
        </div>
        
        

        <modal :show.sync="editSector" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editClient = false; client = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <card class="stacked-form" title="Sektor">
                <form @submit.prevent>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Ime" type="text" v-model="sector.name" placeholder="Ime">
                                </base-input>
                            </div>
                            
                        </div>

                    </div>
                </form>

                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="saveSector()">Sačuvaj</base-button>
                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                    @click="editSector = false; sector = {}">Odustani</base-button>
            </card>

        </modal>

        <modal :show.sync="showParkings" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showParkings = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button><br><br>

            Parking
            <el-select v-model="parking" class="select-primary" name="role" value-key="id">
                <el-option v-for="p in allParkings" class="select-primary" :label="p.name+' '+(p.region?.name || '')" :value="p"
                    :key="p.id"></el-option>
            </el-select>
            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                            @click="assignRegionToParking()">Dodeli parking</base-button>
            <card class="stacked-form" title="">
                <h4>{{ sector.name }}</h4>
                <!-- <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="plate = {}; editPlates = true">Dodaj tablice</base-button> -->
                <el-table :data="parkings" >
                    <el-table-column min-width="80" prop="plates" label="Parking">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="80" prop="active" label="Status">
                        <template slot-scope="scope">
                            <span v-if="scope.row.active" style="color: green;">AKTIVAN</span>
                            <span v-else style="color: red;">NIJE AKTIVAN</span>

                        </template>
                    </el-table-column>

                    <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                        <div slot-scope="scope" class="text-right table-actions">

                            <base-button :type="'danger'" class="btn-link"
                                @click="unAssignSector(scope.row)">
                                Obriši
                            </base-button>

                        </div>
                    </el-table-column>
                </el-table>
                <!-- <div class="block">
                    <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPagesPlates }}</span>
                    <base-pagination class="pagination-no-border" v-model="pagePlates"
                        :per-page="maxPlates" :total="totalRecordsPlates" @input="changePagePlates">
                    </base-pagination>
                </div> -->
            </card>

        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getSectors()
        this.getAllParkings()
        // this.getUsers()
        // this.getEmployees()
        // this.getKiosks()
        // this.getRegions()
        // this.getRoles()
    },
    data() {
        return {
            activeName: 'first',
            sectors: [],
            url: 'https://budva.scancar.org:8443/kuca',
            zonesLoading: false,
            sector: {},
            editSector: false,
            parkings: [],
            showParkings: false,
            parking: {},
            allParkings: []
        };
    },
    methods: {
        assignRegionToParking(){
            this.loading = true
            this.parking.region = this.sector
            axios.post(this.url + '/settings/assignRegionToParking', this.parking).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.getSectorParkings()
                } else {

                }
            })
        },
        unAssignSector(parking){
            this.loading = true
            axios.post(this.url + '/settings/unAssignRegionFromParking', parking).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.getSectorParkings()
                } else {

                }
            })
        },
        getSectors() {
            this.zonesLoading = true
            axios.get(this.url + '/settings/getRegions').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.sectors = result.data.regions
                } else {

                }
            })
        },
        getAllParkings() {
            axios.get(this.url + '/settings/getAllParkings').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.allParkings = result.data.parkings
                } else {

                }
            })
        },
        getSectorParkings() {
            this.loading = true
            axios.get(this.url + '/settings/getRegionParkings?regionId='+this.sector.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.parkings = result.data.parkings
                    this.showParkings = true
                } else {

                }
            })
        },
        
        saveSector () {
            this.loading = true
            axios.post(this.url + '/settings/saveRegion', this.sector).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editSector = false
                    this.sector = {}
                    this.getSectors()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>